// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"806":"404view","966":"login"}[chunkId] + "." + {"806":"eb2b37c4","966":"b5624fb7"}[chunkId] + ".js";
};